import React, { useCallback, useEffect } from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link, useHistory } from 'react-router-dom';

import ContactUsLink from '@src/components/ContactUsLink';

import '@src/css/metlife_css/buttons.scss';

import styles from './error.scss';

const Error404 = ({ type = 'page' }) => {
    const history = useHistory();

    const handleBack = useCallback((e) => {
        e.preventDefault();
        history.goBack();
    }, [history]);

    useEffect(() => {
        const prevTitle = document.title;
        document.title = 'Page Not Found | ' + prevTitle;
    }, []);

    return (
        <Container id="home" className={styles.error_page}>
            <Row>
                <Col className="text-center">
                    <div className="error-container">
                        <img src="/img/404-icon.svg" alt="Magnifying Glass" />
                        <h1>Oops!</h1>
                        <h2>That {type} could not be found.</h2>
                        <p>Try another URL or <a className="ml-link" onClick={handleBack} >go back to a previous page</a>.</p>
                        <p>For more support please <ContactUsLink>contact us</ContactUsLink>.</p>
                        <p>Or <Link to="/search" className="ml-link">Search</Link> for content here</p>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

Error404.propTypes = {
    type: PropTypes.string,
};

export default Error404;
